import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

import { NewsItem } from "core/http/service/news/resTypes";

interface InitialState {
  status: ReduxStateType;
  data: NewsItem;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: {},
};

const getNewsDetailSlice = createSlice({
  name: "getNewsDetail",
  initialState,
  reducers: {
    getNewsDetailStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getNewsDetailSuccess: (state, action: PayloadAction<any>) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getNewsDetailFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetNewsDetail: () => {
      return { ...initialState };
    },
  },
});

export const {
  getNewsDetailStart,
  getNewsDetailSuccess,
  getNewsDetailFailed,
  resetNewsDetail,
} = getNewsDetailSlice.actions;

export default getNewsDetailSlice.reducer;
